import { createSlice } from "@reduxjs/toolkit";
// CONTRACT REDUCER
const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:Contracts.index" },
      { key: "[co].name", name: "global:Contracts.contact" },
      { key: "numberContract", name: "global:contract.numberContract" },
      { key: "title", name: "global:contract.title" },
      { key: "[ct].entryName", name: "global:contract.contractType" },
      { key: "[s].name", name: "global:Contracts.status" },
    ],
    selectedSearchFields: [
      "index",
      "[co].name",
      "numberContract",
      "title",
      "[ct].entryName",
      "[s].name",
    ],
    dictionaryFields: ["contractType"],
    url: "contract",
  },
};

const contractReducer = createSlice({
  name: "contractReducer",
  initialState,
  reducers: {
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = contractReducer.actions;

export default contractReducer.reducer;
